import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardBody,
  CardHeader,
  Input,
  FormGroup,
  FormFeedback,
  Label,
  Col,
  Row
} from "reactstrap";
import { Field } from "formik";

import errorsForField from "shared/formik/errorsForField";
import { Select } from "shared/formik/formik_helpers";
import FormRowField from "shared/react_components/FormRowField";
import AddList from "shared/react_components/AddList";

const UserInformation = ({ timeZones, manageUsernames }) => (
  <Card>
    <CardHeader tag="h3">User Information</CardHeader>
    <CardBody>
      <Row>
        <Col md={9}>
          <FormGroup name="emailGroup" className="sb-field-group">
            <Label className="sb-field-label">Email</Label>
            <Field name="user.emails">
              {({ field: { value: fieldValue, name: fieldName }, form }) => {
                return (
                  <AddList
                    items={fieldValue}
                    emptyItem={{ value: "", label: "" }}
                    onChange={value => form.setFieldValue(fieldName, value)}
                    addButtonVisible={manageUsernames}
                    deleteButtonVisible={manageUsernames}
                    canDeleteItem={({ verified, notify }) =>
                      (!verified ||
                        fieldValue.filter(({ verified }) => verified).length >
                          1) &&
                      (!notify ||
                        fieldValue.filter(({ notify }) => notify).length > 1)
                    }
                    disabledCloseButtonTooltip="Must have at least one verified email and one email that is enabled to receive notifications"
                  >
                    {({ item, fieldUpdater, index }) => (
                      <FormGroup>
                        <Input
                          value={item.email}
                          readOnly={!manageUsernames || item.submitted}
                          onChange={({ target: { value } }) =>
                            fieldUpdater.updateItemValues({
                              value,
                              label: value,
                              email: value,
                              submitted: false,
                              notify: true
                            })
                          }
                        />
                        <FormFeedback className="d-block">
                          {errorsForField(form, `user.emails[${index}].email`, {
                            requireTouched: false
                          })}
                        </FormFeedback>
                      </FormGroup>
                    )}
                  </AddList>
                );
              }}
            </Field>
          </FormGroup>
          <FormRowField name="user.firstName" label="First Name">
            {({ field }) => <Input {...field} />}
          </FormRowField>
          <FormRowField name="user.lastName" label="Last Name">
            {({ field }) => <Input {...field} />}
          </FormRowField>
          <FormRowField name="user.phoneNumber" label="Phone Number">
            {({ field }) => <Input {...field} />}
          </FormRowField>
          <FormGroup name="timeZoneGroup" className="sb-field-group">
            <Label className="sb-field-label">Time Zone</Label>
            <Field
              name="user.timeZone"
              label="Time Zone"
              component={Select}
              options={timeZones}
            />
          </FormGroup>
        </Col>
      </Row>
    </CardBody>
  </Card>
);

UserInformation.propTypes = {
  /** the list of Time Zones that a user can select for themselves */
  timeZones: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ),
  /** determines if we should enable username management  */
  manageUsernames: PropTypes.bool
};

export default UserInformation;
